var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlCleaningServiceFilled = function SvgHtlCleaningServiceFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.676 14.994a5.226 5.226 0 0 0 .667-2.94.5.5 0 0 0-.5-.489h-.012a.493.493 0 0 0-.35.155.491.491 0 0 0-.139.356 4.155 4.155 0 0 1-.873 2.918h-1.4a4.74 4.74 0 0 0 .952-2.943.5.5 0 0 0-.5-.486h-.014a.5.5 0 0 0-.486.514 4.135 4.135 0 0 1-1.252 2.915h-1.47a.5.5 0 0 1-.46-.3.5.5 0 0 1 .1-.542 3.344 3.344 0 0 0 1.063-2.167v-2.49a.5.5 0 0 1 .5-.5h2.5v-7.5a.5.5 0 1 1 1 0v7.5h2.5a.5.5 0 0 1 .5.5v2.5a3.839 3.839 0 0 1-.947 2.87.5.5 0 0 1-.343.136l-1.036-.007Zm-7.176-2a.5.5 0 1 1 0-1h1a.5.5 0 0 1 0 1h-1Zm.5-2a.5.5 0 1 1 0-1h.5a.5.5 0 1 1 0 1H4Z"
  })));
};
export default SvgHtlCleaningServiceFilled;